import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  termsContainer: () => css`
    h2 {
      text-align: center;
      margin-top: 120px;
    }
  `,
})

export default useStyles
